import * as React from 'react'
import {useContext} from 'react'
import { StandardTextFieldProps } from '@mui/material/TextField';
import {createErrorHandlingForm, ErrorHandlingFormProps} from './hoc/createErrorHandlingForm'
import {EnterKeyHandlerProps, withEnterKeyHandler} from './hoc/withEnterKeyHandler'
import {AppAdminContext} from '../../../app/AppAdminContext'
import styled from 'styled-components'

import { TextField } from '@mui/material';

const PPTextField = (props: StandardTextFieldProps & ErrorHandlingFormProps & EnterKeyHandlerProps) => {
    const {variant, hasError, messages, clearErrorMessage, eventKeys, eventEmitter, ...rest} = props
    const {showSpModePage} = useContext(AppAdminContext)
    return <StyledTextField
        {...rest}
        $spMode={!variant && showSpModePage}
        variant={variant ?? (showSpModePage ? 'outlined' : 'standard')}
        error={hasError}
    />
}

const StyledTextField = styled(TextField)<{ $spMode: boolean }>`
  ${props => props.$spMode && `
  .MuiInputBase-input {
    padding: 15px 3px;
  }
  `}
`

PPTextField.displayName = 'PPTextField'
export default createErrorHandlingForm(withEnterKeyHandler(PPTextField))
